import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface User {
  id: string
  email: string
  firstName: string
  lastName: string
  role: string
  tenantId: string
  mustChangePassword?: boolean
}

interface AuthState {
  accessToken: string | null
  refreshToken: string | null
  user: User | null
  isAuthenticated: boolean
  tokenValidated: boolean
  setAuth: (accessToken: string, refreshToken: string, user: User) => void
  setTokens: (accessToken: string, refreshToken: string) => void
  logout: () => void
  setTokenValidated: (v: boolean) => void
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      accessToken: null,
      refreshToken: null,
      user: null,
      isAuthenticated: false,
      tokenValidated: false,
      setAuth: (accessToken, refreshToken, user) =>
        set({ accessToken, refreshToken, user, isAuthenticated: true, tokenValidated: true }),
      setTokens: (accessToken, refreshToken) =>
        set((s) => ({ accessToken, refreshToken, user: s.user, isAuthenticated: true })),
      logout: () =>
        set({ accessToken: null, refreshToken: null, user: null, isAuthenticated: false, tokenValidated: true }),
      setTokenValidated: (v) => set({ tokenValidated: v }),
    }),
    {
      name: 'hseq-auth',
      partialize: (s) => ({ accessToken: s.accessToken, refreshToken: s.refreshToken, user: s.user, isAuthenticated: s.isAuthenticated }),
    }
  )
)

// Validate stored token on every app load — clears stale sessions from old deployments
const _authApiBase = import.meta.env.VITE_API_BASE
  ? `${import.meta.env.VITE_API_BASE}/api`
  : '/api'

const state = useAuthStore.getState()
if (state.isAuthenticated && state.accessToken) {
  fetch(`${_authApiBase}/auth/me`, { headers: { Authorization: `Bearer ${state.accessToken}` } })
    .then(r => {
      if (r.status === 401) useAuthStore.getState().logout()
      else useAuthStore.getState().setTokenValidated(true)
    })
    .catch(() => useAuthStore.getState().setTokenValidated(true))
} else {
  useAuthStore.getState().setTokenValidated(true)
}
